import styled, { css } from 'styled-components';
import Button from '@/components/Button';
import {
  IBack,
  ICampaignHeader,
  ICampaignTag,
  IFilterBox,
  IFlex,
  IFormItem,
  IFront,
  IMobileBack,
  IMobileCampaignBox,
  IMobileCampaignTitle,
  IMobileProductDetails,
  IMobileTag,
  ISuccessButton,
  ITagButton,
  ITitleBox,
} from '@/styles/styled.types';
import theme from '@/styles/theme';
import { Div } from '@/common/Div/Div';

export const ContentBox = styled.section`
  background-color: #f4f4f4;
  height: 100%;
  @media screen and (max-width: 480px) {
    background-color: #f4f4f4;
    .accordion {
      &__title {
        font-family: VodafoneLt;
        font-size: 24px;
        line-height: 1.25;
        text-align: center;
        color: #333;
        margin-bottom: 16px;
      }

      &__content {
        display: flex;
        margin-bottom: 20px;

        &__inner {
          flex: 1;
          margin-left: 16px;
          font-size: 16px;
          line-height: 1.38;
          color: #333;
        }

        span {
          max-width: 32px;
          max-height: 32px;
          align-self: center;
        }

        b {
          font-weight: bold;
        }
      }
    }
  }
`;

export const Title = styled.div`
  font-size: 28px;
  font-weight: 400;
  line-height: 34px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  max-width: 1030px;
  color: #333333;
  margin-bottom: 40px;
  @media screen and (max-width: 480px) {
    font-size: 20px;
    font-weight: bold;
    line-height: 1.4;
    margin-bottom: 32px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const TitleAddressPageMobile = styled.div`
  display: none;

  @media screen and (max-width: 480px) {
    display: flex;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
    justify-content: flex-start;
    align-items: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    max-width: 1030px;
    color: #333333;
  }
`;

export const TitleAddressPage = styled.div`
  font-size: 28px;
  font-weight: 400;
  line-height: 34px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  max-width: 1030px;
  color: #262626;
  @media screen and (max-width: 480px) {
    display: none;
  }
`;

export const Box = styled.div`
  height: 100vh;
  @media screen and (max-width: 480px) {
    padding: 0 16px;
  }
`;

export const TitleBox = styled.div<ITitleBox>`
  width: 100%;
  display: flex;
  margin-top: 40px;
  // display: ${({ sid }) => (sid ? 'block' : 'flex')};
  align-items: center;
  justify-content: center;
  flex-direction: column;
  top: -50%;
  padding: ${({ sid }) => (sid ? '0px 125px 141px' : '0px 125px 40px')};
  @media screen and (max-width: 768px) {
    margin-top: 24px;
    padding: 0;
    display: flex;
  }
`;

export const AddressBox = styled.section`
  padding: 64px 175px 128px;
  min-height: 100vh;
  background: #f4f4f4;
  @media screen and (max-width: 768px) {
    padding: 32px 16px 53px;
    min-height: 120vh;
    margin-top: -20px;
  }
`;
export const AddressBox2 = styled.section`
  padding: 0px 175px 128px;
  min-height: 100vh;
  background: #f4f4f4;
  @media screen and (max-width: 768px) {
    padding: 32px 16px 53px;
    min-height: 120vh;
    margin-top: -20px;
  }
`;

export const FormBox = styled.form``;

export const ChangeMobileNumber = styled.div`
  display: none;
  @media (max-width: 786px) {
    width: 100%;
    z-index: 80;
    // margin-top: -8px;
    height: 72px;
    padding: 24px 20px;
    margin-bottom: 24px;
    object-fit: contain;
    border-radius: 6px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
    text-align: left;
    font-size: 16px;
    line-height: 1.38;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  span:hover {
    cursor: pointer;
  }
`;

export const MobileNumberText = styled.div`
  display: flex;
  align-item: center;
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;

  p {
    &:first-child {
      font-family: VodafoneRg;
      color: #666666;
      font-size: 14px;
      line-height: 18px;
    }
  }
`;

export const CircleLoading = styled.div`
  margin: 0 auto;
  font-size: 10px;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.2);
  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
  border-left: 1.1em solid #e60000;
  transform: translateZ(0);
  -webkit-animation: 1.1s linear infinite load8;
  animation: 1.1s linear infinite load8;
  left: 45%;
  top: 40%;
  position: fixed;
  z-index: 9999;
  border-radius: 50%;
  width: 10em;
  height: 10em;

  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  &:after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
  }

  @media (max-width: ${theme.breakpoint.small}) {
    left: 38%;
  }
`;
export const TextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  @media (max-width: ${theme.breakpoint.medium}) {
    margin: 0px;
  }
`;

export const AddressTitle = styled.div`
  margin-bottom: 40px;
  font-size: 28px;
  font-weight: 400px;
  line-height: 34px;
  text-align: center;
  color: #333;
  @media screen and (max-width: 480px) {
    margin-bottom: 32px;
    font-size: 20px;
    font-weight: 400px;
    line-height: 28px;
  }
`;

export const AddressForm = styled.div`
  padding: 20px 18px 20px 20px;
  border-radius: 6px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  max-width: 610px;
  margin: auto;
  margin-top: 40px;

  @media screen and (max-width: 480px) {
    padding: 16px;
    margin-top: 20px;
    margin-bottom: 12px;
  }
`;

export const FormItem = styled.div<IFormItem>`
  margin-bottom: 23px;
  display: ${({ isMobile, show }) => (isMobile && show ? show : 'block')};
`;

export const FormText = styled.div`
  @media screen and (max-width: 480px) {
    font-size: 14px;
    line-height: 1.29;
    color: #666;
    margin-top: 4px;
    margin-left: 12px;
  }
`;

export const AddressText = styled.div`
  font-size: 20px;
  line-height: 28px;
  color: #333;
  margin-bottom: 20px;
`;

export const InfoText = styled.div`
  font-size: 14px;
  line-height: 1.29;
  color: #666;
  display: flex;
  align-items: center;
  margin: 30px auto auto;
  width: 100%;
  justify-content: center;
  @media screen and (max-width: 480px) {
    margin-top: 28px;
  }

  div {
    margin-right: 10px;
    @media screen and (max-width: 480px) {
      margin-right: 16px;
      span {
        width: 32px !important;
        height: 32px !important;
      }
    }
  }
`;

export const ErrorModalBox = styled.div`
  width: 610px;
  height: 428px;
  padding: 32px 32px 40px;
  border-radius: 6px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  text-align: center;

  > :last-child {
    max-width: 277px;
    margin: auto;
  }

  @media screen and (max-width: 480px) {
    width: 100%;
    height: 100%;
    padding: 16px 16px 32px;
    display: flex;
    flex-direction: column;
    > :last-child {
      margin: auto 0 0;
      max-width: 100%;
    }
  }

  .modal-content {
    display: flex;
    margin-bottom: 20px;

    p {
      font-family: VodafoneRg;
      font-size: 18px;
      font-weight: bold;
      line-height: 1.33;
      text-align: center;
      color: #333;
      flex: 1;
      margin-right: auto;
      @media screen and (max-width: 480px) {
        font-family: VodafoneRg;
        font-size: 18px;
        font-weight: bold;
        line-height: 1.33;
      }
    }

    span {
      &:hover {
        cursor: pointer;
      }
    }
  }

  span {
    @media screen and (max-width: 480px) {
      margin-top: auto !important;
    }
  }

  h1 {
    font-family: VodafoneRg;
    font-size: 28px;
    font-weight: bold;
    line-height: 1.21;
    color: #333;
    margin-top: 20px;
    @media screen and (max-width: 480px) {
      font-family: VodafoneRg;
      font-size: 24px;
      font-weight: bold;
      line-height: 1.25;
      margin-top: 32px;
    }
  }

  h2 {
    font-family: VodafoneRg;
    font-size: 18px;
    line-height: 1.33;
    color: #333;
    margin-top: 20px;
    margin-bottom: 40px;
    @media screen and (max-width: 480px) {
      font-family: VodafoneRg;
      font-size: 18px;
      line-height: 1.33;
      margin-top: 16px;
      margin-bottom: 0;
    }
  }
`;

export const TabStyled = styled.div`
  display: flex;
  padding: 0 125px;
  height: 52px;
  background-color: #fff;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 480px) {
    padding: 0;
    overflow-y: scroll;
    justify-content: center;
  }
`;

export const Banner = styled.div<ImageContainerProps>(({ mobileImage }) => {
  return css`
    @media screen and (max-width: 768px) {
      background-image: url(${mobileImage});
      height: 150px;
      background-size: contain;
      padding: 12px 0 0 16px;
      background-repeat: no-repeat;
    }
  `;
});

export const YasalText = styled.div`
  margin-left: auto;
  display: none;
  cursor: pointer;
  color: #ffffff;
  padding-top: 35px;
  gap: 20px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  justify-content: space-between;

  @media screen and (max-width: 480px) {
    display: flex;
    align-items: center;
    // padding-top: 25px;
    margin-top: -50px;
  }
`;

export const YasalTextFullPage = styled.div`
  margin-left: auto;
  display: flex;
  cursor: pointer;
  color: #ffffff;
  padding: 15px 0 15px 0;
  gap: 20px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  justify-content: space-between;

  @media screen and (max-width: 375px) {
    display: flex;
    align-items: center;
    padding: 15px 0 10px 0;
    margin-top: -20px;
  }

  @media screen and (max-width: 374px) and (max-width: 653px) {
    display: flex;
    align-items: center;
    padding: 15px 0 10px 0;
    margin-top: -40px;
  }
`;

export const KvkkFragment = styled.section`
  display: block;
  position: relative;
  .error-message {
    position: relative;
    bottom: 105px;
    margin-left: 0px;
    @media (min-width: 328px) {
      bottom: 10px;
    }
  }
`;
export const KvkkCheckBox = styled.label`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  width: 100%;
  position: relative;
  //bottom: 40px;
  @media (min-width: 328px) {
    bottom: -30px;
    line-height: 18px;
    margin-top: -15px;
  }

  .loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: black;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  span {
    color: #ff0000;
    text-decoration: underline;
  }

  input[type='checkbox'] {
    opacity: 0;
    position: absolute;
    width: 30px;
    height: 20px;
    cursor: pointer;
  }

  .checkmark {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 1px solid #fff;
    border-radius: 3px;
    margin-right: 8px;
  }
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
    left: 5px;
    top: 1px;
    width: 5px;
    height: 10px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  input[type='checkbox']:checked + .checkmark:after {
    display: block;
  }
`;
interface OneClickProps {
  inApp: boolean;
}

export const OneClickBox = styled.section<OneClickProps>`
  width: 100%;
  height: 100%;
  margin: 0;
  position: relative;
  padding: 0 20px 0 20px;
  background: ${({ inApp }) =>
    inApp
      ? 'rgba(0, 0, 0, 0.3)'
      : 'var(--Linear-footer, linear-gradient(270deg, #333 0%, #000 100%))'};
  z-index: ${({ inApp }) => (inApp ? '10' : '0')};
  display: ${({ inApp }) => (inApp ? 'flex' : '')};
  justify-content: ${({ inApp }) => (inApp ? 'center' : '')};
  align-items: ${({ inApp }) => (inApp ? 'center' : '')};
  opacity: ${({ inApp }) => (inApp ? '95%' : '')};

  .inAppFragment {
    border-radius: 6px;
    z-index: 999;
    padding: 10px 15px 10px 15px;
    width: 100%;
    max-width: 328px;
    height: 589px;
    display: block;
    flex-direction: column;
    justify-content: center;
    text-decoration-line: none;
    background: var(
      --Linear-footer,
      linear-gradient(270deg, #333 0%, #000 100%)
    );

    #closeId {
      text-decoration-line: none;
    }
  }
  .inAppBack {
    margin-top: 15px;
    margin-bottom: -20px;
    display: flex;
    justify-content: right;
    margin-right: 12px;
    text-decoration: none;
    color: #ffffff;
    font-size: 15px;
    font-weight: 700;

    .inApp {
      margin-top: -10px;
      text-decoration: none;
      text-decoration-line: none;
    }
  }
`;

interface ImageContainerProps {
  mobileImage: string;
}

export const ImageContainer = styled.div<ImageContainerProps>(
  ({ mobileImage }) => {
    return css`
      @media screen and (max-width: 768px) {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 333px;
        border-radius: 6px;
        text-align: start;
        color: #fff;
        padding: 18px 0 0 20px;
        gap: 10px;
        background-image: url(${mobileImage});
        background-size: cover;
        z-index: -1;
      }
    `;
  }
);
export const InfoDescription = styled.h2`
  padding: 10px 30px 0px 30px;
  font-size: 14px;
  font-weight: 400px;
  line-height: 18px;
  color: white;
  overflow-y: auto;
  height: 80%;
  p {
    line-height: 22px;
    font-size: 18px;
  }
  h5 {
    padding-bottom: 10px;
    font-size: 18px;
    font-weight: 700;
    line-heilght: 24px;
  }
  span {
    color: #ff0000;
    text-decoration: underline;
  }
`;
export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

export const Label = styled.label`
  margin-left: 0.5rem;
  color: white;
`;

export const TariffClaim = styled.div`
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin-top: -10px;
  @media screen and (max-width: 480px) {
    padding-bottom: 8px;
    margin-top: -10px;
  }
`;

export const HeadStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  margin-top: 35px;
  padding-left: 20%;
`;
export const PageHeader = styled.h1`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: #333;
  letter-spacing: 0px;
  color: white;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  justify-content: center;
`;

export const InAppBanner = styled.div`
  margin-top: -15px;
`;

export const InfoMessage = styled.div`
  color: #ffffff;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  line-height: 18px;
  margin-top: 15px;
  gap: 5px;
`;
export const InfoMessageFull = styled.div`
  color: #ffffff;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  line-height: 18px;
  font-weight: 200;
  gap: 5px;
  margin-top: 10px;
`;
export const PageDescription = styled.h4`
  color: #fff;
  text-align: start;
  padding: 50px 0px 20px 0px;

  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  @media (min-width: 328px) {
    padding: 35px 0 5px 0px;
  }
`;

export const PageDescriptionInApp = styled.h4`
  color: #fff;
  text-align: start;
  padding: 45px 0px 20px 0px;

  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  @media (min-width: 328px) {
    padding: 35px 0 10px 0px;
  }
`;
export const TarifeTitle = styled.h5<any>`
  font-size: 20px;
  color: #262626;
  font-weight: 400;
  line-height: 28px;
  margin-bottom:36px;
  margin-top: ${({ containerIsHidden }) => (!containerIsHidden ? '40px' : '0px')};

  @media screen and (max-width: 480px) {
    font-size: 16px;
    line-height: 22px;
    color: #262626;
    font-weight: 400;
    margin-bottom:16px;
    margin-top: ${({ containerIsHidden }) =>
      !containerIsHidden ? '44px' : '8px'};
    margin-left:0px;
    margin-right:0px;


`;
export const TarifeDescription = styled.h4`
font-size: 20px;
  color: #262626;
  font-weight: 400;
  line-height: 28px;
  padding-top: 8px;
  padding-bottom: 8px;



  @media screen and (max-width: 480px) {
    font-size: 16px;
    line-height: 22px;
    color: #262626;
    font-weight: 400;
`;
export const ApproveDesc = styled.h4`
  color: #fff;
  padding: 45px 0px 20px 0px;

  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  @media (min-width: 328px) {
    padding: 50px 0px 20px 0px;
    font-size: 18px;
    line-height: 24px;
  }
`;
export const ApproveDescInApp = styled.h4`
  color: #fff;
  padding: 45px 0px 20px 0px;

  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  @media (min-width: 328px) {
    padding: 30px 0px 20px 0px;
    font-size: 18px;
    line-height: 24px;
  }
`;

export const TextNumber = styled.h4`
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 137.5% */
  gap: 5px;
  display: grid;
  padding: 10px 0 5px 0;

  span {
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }
  @media (min-width: 328px) {
    padding: 5px 0 5px 0;
  }
`;

export const TextAddress = styled.h4`
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  gap: 5px;

  padding: 20px 0 5px 0;

  span {
    color: #fff;

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  .address-box {
    padding-top: 10px;
    flex-direction: row;
    display: flex;
    gap: 10px;
  }

  .addressEdit {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: -5px;
    align-items: center;
  }
  .addressEditInApp {
    display: flex;
    flex-direction: row;
    gap: 30%;
    margin-bottom: -5px;
    padding-top: 15px;
  }
`;

export const CampaignCard = styled.div`
  @media screen and (max-width: 1200px) {
    display: none;
  }
  background: linear-gradient(45deg, #820000, #e60000);
  max-width: 1570px;
  height: auto;
  border-radius: 6px;
  margin-bottom: 40px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MobileCampaignCard = styled.div`
  @media screen and (min-width: 1200px) {
    display: none;
  }
  background: linear-gradient(45deg, #820000, #e60000);
  width: 100%;
  border-radius: 6px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;

  img {
    padding-left: 70px;
  }

  span {
    margin-left: -35px !important;

    img {
      margin-left: 35px !important;
    }
  }

  .second-text {
    font-size: 12px;
    margin-bottom: 5px;
  }

  div {
    padding-left: 16px;
    flex: 1;
    color: #ffffff;
    gap: 5px;

    p {
      line-height: 18px;
      font-family: VodafoneRg;

      &:nth-child(1) {
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 16px;

        b {
          font-family: VodafoneBold;
        }
      }

      &:nth-child(3) {
        font-size: 12px;

        b {
          font-family: VodafoneBold;
        }
      }
    }
  }
`;

export const CampaignCardText = styled.div`
  color: #ffffff;

  h2 {
    text-align: center;
    font-size: 28px;
    line-height: 34px;
    font-family: VodafoneRg;

    span {
      font-family: VodafoneBold;
      text-align: center;
    }
  }

  h5 {
    text-align: center;
  }

  p {
    margin-top: 2px;
    font-size: 20px;
    line-height: 28px;
    text-align: center;

    span {
      font-family: VodafoneBold;
    }
  }
`;

export const FilterBox = styled.div<IFilterBox>`
  font-size: 16px;
  line-height: 1.5;
  color: #666;
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  @media screen and (max-width: 480px) {
    margin-bottom: 0px;
    /* margin-bottom: ${({ tariffGroup }) =>
      tariffGroup?.length ? '16px' : '0'}; */
  }
`;

export const TagsBox = styled.div`
  display: flex;
  align-items: center;
  overflow-x: auto;
  @media screen and (max-width: 768px) {
    margin-bottom: 22px;
  }
`;

export const SortBox = styled.div`
  max-width: 320px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    font-size: 16px;
    line-height: 1.5;
    color: #666;
  }

  select {
    flex: 1;
    max-width: 250px;
    margin-left: 16px;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M24 0v24H0V0z'/%3E%3Cpath stroke='%23333' stroke-linecap='round' stroke-linejoin='round' d='M20.5 8.5 12 17 3.5 8.5'/%3E%3C/g%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 1em;
    border-radius: 6px;
    border: 1px solid #999;
    background-color: #fff;
    padding: 20px;
    object-fit: contain;
    font-size: 14px;
    line-height: 1.29;
    color: #666;

    &:focus {
      outline: none;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
`;

export const TagButton = styled.button<any>`
  flex: none;
  padding: 7px 12px 9px;
  object-fit: contain;
  border-radius: 20px;
  border: none;
  outline: none;
  background-color: ${({ active }) => (active ? '#007c92' : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#333')};
  font-size: 18px;
  line-height: 1.33;
  text-align: center;
  margin-left: 12px;
  display: ${({ all }) => (all ? 'inline-block' : 'inline-block')};
  @media screen and (max-width: 480px) {
    font-size: 16px;
    line-height: 1.38;
    text-align: center;
  }

  @media screen and (max-width: 768px) {
    &:first-child {
      margin-left: 0;
    }
  }

  &:hover {
    cursor: pointer;
  }
`;

export const TarifeBox = styled.section<any>`
  background: #f4f4f4;
  padding: ${({ containerIsHidden }) =>
    !containerIsHidden ? '64px 75px 128px 175px' : '16px 75px 128px 175px'};

  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  @media screen and (max-width: 768px) {
    max-width: 658px;
    margin-top: ${({ containerIsHidden }) =>
      !containerIsHidden ? '52px' : '0px'};
    padding: 32px 16px 53px 16px;
  }
  @media screen and (max-width < 480px) {
    padding: 16px 16px 53px;
  }
`;

export const GridBox = styled.div`
  max-width: 1250px;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
  display: flex;
  flex-direction: row;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const CampaignHeader = styled.div<ICampaignHeader>`
  padding: 16px 35px 8px 16px;
  border-top-right-radius: 6px;
  border-top-left-radius: ${({ tagName }) => (tagName == '' ? '6px' : '0px')};
  position: relative;
  background: ${({ backgroundColor }) =>
    backgroundColor
      ? backgroundColor
      : 'linear-gradient(87.91deg, #967732 8.39%, #C3A453 61.27%, #F1E49C 136.36%)'};
`;

export const CountdownTag = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  height: 34px;
  width: 100%;
  font-size: 16px;
  margin-right: 5px;
  padding: 0 15px;
  line-height: 22px;
  color: #fff;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  position: absolute;
  top: -30px;
  left: 0;
  background: #ab39af;
  gap: 10px;

  span {
    width: 24px !important;
    height: 24px !important;
  }
`;

export const CardMobileTag = styled.div<IMobileTag>`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  height: 34px;
  width: auto;
  font-size: 16px;
  margin-right: 5px;
  padding: 0 15px;
  font-weight: 700;
  line-height: 22px;
  color: #fff;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  position: absolute;
  top: -30px;
  left: 0;
  background-color: ${({ tag, color }) => (tag != '' ? color : 'transparent')};
  gap: 10px;

  span {
    width: 24px !important;
    height: 24px !important;
  }
`;

export const CampaignTag = styled.div<ICampaignTag>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  font-size: 16px;
  margin-right: 5px;
  padding: 0 15px;
  font-weight: 700;
  line-height: 22px;
  color: #fff;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  position: absolute;
  top: -30px;
  left: 0;
  background-color: ${({ name, color }) =>
    name != '' ? color : 'transparent'};
`;

export const CampaignTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  line-height: 1.21;
  color: #fff;
  margin-bottom: 6px;
  img {
    margin-right: 3px !important;
  }
`;

export const CampaignPrice = styled.div`
  span {
    font-size: 22px !important;
    line-height: 1.21;
    color: #fff;
  }
`;

export const ConvergencePrice = styled.div`
  p {
    font-family: VodafoneRg;
    font-size: 18px;
    line-height: 1.21;
    color: #fff;
    margin-bottom: 4px;

    span {
      font-family: Helvetica;
      font-size: 20px;
      line-height: 34px;
      color: #fff;

      &:first-child {
        // text-decoration: line-through;
      }
    }
  }
`;

export const CampaignTime = styled.p`
  font-size: 16px;
  line-height: 22px;
  color: #fff;
  line-height: 1.21;
  font-family: VodafoneRg;

  p {
    font-family: VodafoneRg;
    font-size: 18px;
    line-height: 1.21;
    color: #fff;
    margin-bottom: 4px;
  }

  span {
    // font-weight: bold;
    font-size: 18px;
    &:first-child {
      line-height: 34px;
    }
  }

  div {
    display: inline;
  }
`;

export const ConvergenceCampaignTime = styled.p`
  font-size: 16px;
  line-height: 1.29;
  color: #fff;

  span {
    font-family: Helvetica;
    font-weight: bold;
    font-size: 18px;

    &:first-child {
      // text-decoration: line-through;
    }
  }

  div {
    display: inline;
  }
`;

export const LineWrapper = styled.div`
  width: 280px;
  padding-left: 16px;
  margin: 0px 16px;
`;
export const Line = styled.div`
  width: 280px;
  height: 1px;

  // background: #ebebeb;
  margin: 0px 16px;
`;

export const CampaignSpeed = styled.div`
  display: flex;
  padding: 16px 0px 0px 16px;
  flex-direction: row;
  align-items: center;
  background-color: #ffff;
  p {
    margin-right: 8px;
    padding-bottom: 8px;
  }
  @media screen and (max-width: 600px) {
    gap: 0;
  }

  div {
  }
`;
export const CampaignName = styled.div`
  display: flex;
  color: #333;
  padding-top: 8px;
  background-color: #ffff;
  padding-left: 20px;
  flex-direction: row;
  align-items: center;

  font-family: VodafoneRg;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
`;

export const DownloadMbps = styled.p`
  font-size: 24px;
  font-weight: bold;
  line-height: 1.42;
  color: #333;
`;

export const ConnectionType = styled.p`
  font-size: 18px;
  line-height: 1.56;
  color: #666;
`;

export const LineWrapperFront = styled.div`
  width: 100%;
  padding-bottom: 16px;
  margin: 0px 16px;
`;
export const LineFront = styled.div`
  width: 100%;
  height: 1px;
  background: #ebebeb;
`;

export const CampaignSpeedFront = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;

  background-color: #ffff;

  @media screen and (max-width: 600px) {
    gap: 0;
  }

  div {
  }
`;
export const CampaignNameFront = styled.div`
  display: flex;
  color: #333;
  padding-top: 8px;
  background-color: #ffff;
  padding-left: 20px;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
`;

export const DownloadMbpsFront = styled.p`
  margin-top: 18px;
  margin-bottom: 18px;

  font-size: 24px;
  font-weight: bold;
  line-height: 1.42;
  margin-right: 8px;
  color: #333;
`;

export const ConnectionTypeFront = styled.p`
  margin-top: 18px;
  margin-bottom: 18px;

  font-size: 20px;
  line-height: 1.56;
  font-weight: 200 !important;
`;

export const CampaignDescription = styled.div`
  background-color: white;
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 285px;
  p {
    min-height: 36px;
  }
`;
export const TariffCardButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: 0;
  padding: 20px 20px 20px 0px;

  button {
    width: 150px;
    margin-right: 20px;
  }
`;

export const Front = styled.div<IFront>`
  display: ${({ show }) => (show ? 'none' : 'block')};

  font-family: VodafoneRg;
  div {
    font-size: 17px;
    line-height: 1.33;
    color: #333;
    display: flex;
    margin-left: 2px;
    span {
      width: 100% !important;
      height: 100% !important;
      max-width: 24px !important;
      max-height: 24px !important;
    }

    #detail-element-li {
      font-size: 17px;
      line-height: 1.33;
      color: #333;
      min-height: 38px;
      display: flex;
      margin-left: 2px;
    }
  }

  #front-desktop {
    font-family: VodafoneRg;
    font-size: 18px;
    line-height: 1.21;
  }

  @media screen and (max-width: 768px) {
    display: block;
    min-height: 28px;
  }
`;

export const MobileBack = styled.div<IMobileBack>`
  display: ${({ show }) => (show ? 'block' : 'none')};
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 128px);

  ul {
    list-style: inside
      url('https://cms.vodafone.com.tr/static/img/content/23-01/05/dot.png');
  }

  li {
    font-size: 18px;
    line-height: 1.33;
    color: #333;
    margin-bottom: 16px;
    ul {
      list-style: inside
        url('https://cms.vodafone.com.tr/static/img/content/23-01/05/dot.png');
    }

    span {
      vertical-align: top;
    }
  }

  @media screen and (max-width: 480px) {
    display: block;
    li {
      font-size: 16px;
    }
  }
`;

export const CardButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-top: 5px;

  #gray-btn {
    color: black;
    border: 1px solid #999999;
    background: #ffffff;

    border-radius: 6px;
    border: 1px 0px 0px 0px;
    opacity: 0px;
  }
  button {
    width: 100%;
    min-width: 140px;
  }
  @media screen and (max-width: 480px) {
  }
`;

export const Back = styled.div<IBack>`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: absolute;
  background-color: #fff;
  top: 54px;
  padding: 10px;
  height: 435px;
  left: 0;
  z-index: 1;

  ul {
    list-style: inside
      url('https://cms.vodafone.com.tr/static/img/content/23-01/05/dot.png');

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-button {
      width: 0px;
      height: 0px;
    }

    &::-webkit-scrollbar-thumb {
      background: #cccccc;
      border: 0px none #ffffff;
      border-radius: 38px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #cccccc;
    }

    &::-webkit-scrollbar-thumb:active {
      background: #cccccc;
    }

    &::-webkit-scrollbar-track {
      background: #ffffff;
      border: 0px none #ffffff;
      border-radius: 6px;
    }

    &::-webkit-scrollbar-track:hover {
      background: #ffffff;
    }

    &::-webkit-scrollbar-track:active {
      background: #ffffff;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }
  }

  li {
    font-size: 18px;
    line-height: 1.33;
    color: #333;
    margin-bottom: 16px;

    span {
      vertical-align: top;
    }
  }

  @media screen and (max-width: 480px) {
    display: block;

    li {
      font-size: 16px;
    }
  }
`;

export const SeeDetails = styled.span`
  font-size: 18px;
  line-height: 1.33;
  color: #e60000;
  text-align: center;
  margin: auto auto 14px;
  z-index: 2;

  &:hover {
    cursor: pointer;
  }
`;

export const CampaignFooter = styled.div`
  padding: 16px 13px 16px 17px;
  display: flex;

  span {
    font-size: 18px;
    line-height: 1.33;
    color: #333;
    margin-left: 13px;
  }
`;
export const MobileCampaignBox = styled.div<IMobileCampaignBox>`
  display: flex;
  border-radius: 6px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  position: relative;
  flex-direction: column;

  ${({ choosenPackage }) =>
    choosenPackage &&
    css`
      border: 1px solid #009900;

      b {
        right: -1px;
        top: -1px;
        border-top: 12px solid #009900;
        border-right: 12px solid transparent;
        border-left: 12px solid #009900;
        border-bottom: 12px solid transparent;
        border-radius: 4px;
        transform: rotate(90deg);
        -ms-transform: rotate(90deg); /* IE 9 */
        -webkit-transform: rotate(90deg); /* Chrome, Safari, Opera */
        position: absolute;

        .checkmark {
          opacity: 1;
          height: 6px;
          width: 10px;
          -ms-transform-origin: left top;
          border-right: 2px solid #fff;
          border-top: 2px solid #fff;
          content: '';
          left: -10px;
          top: -8px;
          position: absolute;
          transform: rotate(40deg);
          -ms-transform: rotate(40deg); /* IE 9 */
          -webkit-transform: rotate(40deg); /* Chrome, Safari, Opera */
        }
      }
    `}
`;
export const OneClickCampaignBox = styled.div`
  display: flex;
  border-radius: 6px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
  border-radius: 6px;
  border: 1px solid #e60000;
  flex-direction: column;
  height: 125px;
  padding: 10px;
  margin-bottom: 10px;
  z-index: 2;
  opacity: 90%;
`;

export const FlexContent = styled.div`
  flex: 1;
`;

export const MobileCampaignTitle = styled.div<IMobileCampaignTitle>`
  display: flex;
  justify-content: space-between;
  border-top-right-radius: ${({ tag }) => (tag ? '12px' : '12px')};
  border-top-left-radius: ${({ tag }) => (tag == '' ? '6px' : '0px')};
  font-size: 20px;
  font-weight: bold;
  line-height: 1.4;
  background: ${({ color }) => color?.replace(/\s+/g, ' ')};
  * {
    color: ${({ color }) => (color ? color.replace(/\s+/g, ' ') : '#ffff')};
  }
  padding: 12px 16px 12px 16px;
  gap: 0px;

  justify: space-between;
  opacity: 0px;
  color: white;
`;

export const MobileCampaignTitleWrapper = styled.div<IMobileCampaignTitle>`
  background: ${({ color }) => color?.replace(/\s+/g, ' ')};
  border-top-right-radius: ${({ tag }) => (tag ? '6px' : '6px')};
  border-top-left-radius: ${({ tag }) => (tag == '' ? '6px' : '0px')};
  * {
    color: ${({ color }) => (color ? color.replace(/\s+/g, ' ') : '#ffff')};
  }
`;
export const MobileCampaignPackageType = styled.div`
  display: flex;
  img {
    margin-right: 4px !important;
  }

  justify-content: flex-start;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.4;
  color: white;
  margin-bottom: 8px;
`;
export const OneClickCampaignTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.4;
  color: #e60000;
  margin-bottom: 8px;
`;
export const OneClickCampaignTag = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  color: white;
  font-weight: bold;
  line-height: 1.4;
  background: #008a00;
  height: auto;
  max-height: 24px;
  align-items: center;
  padding: 8px 16px 8px 16px;
  border-radius: 6px;
  margin-bottom: 8px;
`;

export const MobileCampaignPriceFront = styled.div`
  font-size: 16px;
  line-height: 1.13;
  color: white;
  margin-bottom: 8px;
  p {
    padding: 4px 16px;
  }
`;

export const MobileCampaignPrice = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  p {
    padding: 4px;
  }
`;
export const TarifeBody = styled.div`
  background: #f4f4f4;
  height: 100vh;
`;

export const OneClickCampaignPrice = styled.div`
  font-size: 16px;
  line-height: 1.13;
  color: #333;
  margin-bottom: 8px;
  color: white;
  span {
    font-family: Helvetica;
    font-weight: bold;
    margin-bottom: 0;
  }
  .speed {
    padding-top: 5px;
  }
`;

export const MobileSpeed = styled.div`
  font-size: 16px;
  font-weight: bold;
  line-height: 1.29;
  color: black;
  margin-right: 8px;
`;

export const MobileConnectionType = styled.div`
  font-size: 16px;
  line-height: 1.29;
  color: #666666;
`;
export const MobileTag = styled.div<IMobileTag>`
  font-size: 16px;
  line-height: 1.29;
  text-align: center;
  color: #fff;
  border-radius: 20px;
  background-color: ${({ color }) => color};
  flex: none;
  padding: 0 12px;
  max-width: max-content;
`;
export const MobileTagBox = styled.div`
  display: flex;
  padding-top: 8px;
`;
export const Flex = styled.div<IFlex>`
  display: ${({ show }) => (!show ? 'flex' : 'none')};
  gap: 12px;
  background: '#ffff';

  * {
    color: '#333';
  }
  padding: 12px 16px 24px;
`;
export const AfterClickCampaignTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MobileProductDetails = styled.div<IMobileProductDetails>`
background: #ffffff;
padding: 12px 16px 16px 16px;
border - radius: 6px;
display: ${({ show }) => (show ? 'block' : 'none')};
  .container {
  max - width: 80vw;

    .slick - dots {
  }
}

  button {
  margin - bottom: 16px;
  margin - top: 16px;
}
`;

export const MobileCardFooter = styled.div`
font - size: 18px;
border - top: 1px solid #cccccc;
padding - top: 10px;
padding - left: 4px;
`;

export const PersonalInfo = styled.section`
  position: relative;
  background-color: #f4f4f4;
  padding: 50px 175px 128px;
  @media screen and (max-width: 480px) {
    padding: 25px 16px 16px;
    margin-bottom: 40px;
  }
`;

export const FlexBox = styled.div`
  display: flex;
  gap: 20px;

  @media screen and (max-width: 800px) {
    flex-wrap: wrap;
    flex-direction: column;
  }
`;
export const OneClickSuccessPage = styled.section`
  padding-top: 40px;
  text-align: start;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SuccessPage = styled.section`
  background-color: #f4f4f4;
  padding: 10px 125px 128px;
  text-align: center;
  align-items: center;
  justify-content: center;
  box-shadow: 0px -5px 30px 0px #f4f4f4;
  flex-direction: column;
  display: flex;
  @media screen and (max-width: 480px) {
    padding: 16px 16px 40px;
  }
`;

export const BannerContainer = styled.section`
padding: 0px;
margin: 0px;
display: flex;
justify - content: space - between;
align - items: center;
overflow: hidden;
`;

export const Image = styled.img`
max - width: 100 %;
height: auto;
`;

export const SuccessTitle = styled.h1`
  font-size: 28px;
  font-weight: 400px;
  line-height: 40px;
  color: #333;
  margin-bottom: 40px;

  font-family: VodafoneLt;
  @media screen and (max-width: 480px) {
    font-size: 20px;
    font-weight: 400px;
    line-height: 32px;
    color: #333;
    margin-bottom: 12px;
  }
`;
export const OneClickSuccessTitle = styled.h1`
  color: #fff;
  text-align: center;
  width: 303px;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 140% */
`;
export const SuccessDescription = styled.h2`
font - family: VodafoneLt;
font - size: 28px;
font - weight: 400px;
line - height: 34px;
text - align: center;
color: #333;
max - width: 650px;
margin: 20px 0 40px;
width: 100 %;
@media screen and(max - width: 480px) {
  font - family: VodafoneRg;
  max - width: 400px;
  font - size: 16px;
  line - height: 22px;
  font - weight: 400px;
  text - align: center;
  color: #333;
  margin: 6px 0 20px;
}
`;

export const InfoDesc = styled.h2`
padding: 10px 20px 0 10px;
font - size: 13px;
font - weight: 400px;
line - height: 18px;
color: white;
overflow: scroll;
height: 468px;
scrollbar - width: thin;
scrollbar - color: #000000 #dfe9eb;

  h5 {
  padding - bottom: 10px;
  font - size: 18px;
  font - weight: 700;
  line - heilght: 24px;
}
  span {
  color: #ff0000;
  text - decoration: underline;
}
`;
export const OneClickSuccessDescription = styled.h2`
  padding-top: 15px;
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  display: inline-block;
`;
export const PromoTitle = styled.h1`
padding: 30px 0 5px 0;
text - align: start;
font - size: 18px;
font - style: normal;
font - weight: 700;
line - height: 24px;
color: #ffffff;
`;

export const PromoDesc = styled.h2`
padding - top: 15px;

color: #fff;
text - align: start;
font - size: 16px;
font - style: normal;
font - weight: 400;
line - height: 22px; /* 137.5% */
`;

export const SuccessBox = styled.div`
display: flex;
gap: 20px;
@media screen and(max - width: 800px) {
  flex - wrap: wrap;
  flex - direction: column;
  gap: 16px;
}
border: 1px solid white;
background: transparent;
height: 30px;
padding: 4px 4px;
border - radius: 6px;
display: flex;
align - items: center;
position: relative;
margin - left: 8px;
gap: 6px;

margin - top: 2px;
  .icon {
  display: flex;

  gap: 6px;
}
`;

export const SuccessResult = styled.div`
display: flex;
width: 100 %;
padding: 20px 19px 40px 20px;
border - radius: 6px;
background - color: #fff;
flex - basis: 66.66 %;
gap: 16px;
@media screen and(max - width: 480px) {
  padding: 19px 13px 20px 16px;
  border - radius: 6px;
  background - color: #fff;
  width: 100 %;
}
@media screen and(max - width: 900px) {
    span {
    max - width: 96px!important;
    max - height: 96px!important;
  }
}

  h3 {
  font - family: VodafoneLt;
  font - size: 28px;
  line - height: 1.21;
  color: #333;
  @media screen and(max - width: 480px) {
    font - family: VodafoneRg;
    font - size: 20px;
    line - height: 1.4;
  }
}

  h4 {
  font - family: VodafoneLt;
  font - size: 40px;
  line - height: 1.2;
  color: #333;
  margin - bottom: 32px;
  @media screen and(max - width: 480px) {
    font - size: 24px;
    line - height: 1.25;
    margin - bottom: 16px;
  }
}

h3: not(: first - child) {
  font - family: VodafoneRg;
  font - size: 18px;
  line - height: 1.33;
  color: #333;
  @media screen and(max - width: 480px) {
    font - size: 16px;
    line - height: 1.38;
  }
}

h4: not(: nth - child(2)) {
  font - family: VodafoneRg;
  font - size: 20px;
  font - weight: bold;
  line - height: 1.4;
  color: #333;
  margin - bottom: 20px;
  @media screen and(max - width: 480px) {
    font - size: 24px;
    font - weight: bold;
    line - height: 1.25;
    margin - bottom: 16px;
  }
}
`;

export const SuccessContent = styled.div`
flex: 1;
text - align: left;
`;

export const SuccessAds = styled.div`
width: 100 %;
padding: 20px 0 0;
border - radius: 6px;
background - image: linear - gradient(31deg, #820000, #e60000, #e60000);
flex - basis: 33.33 %;
`;
export const ButtonChange = styled(Button)<ISuccessButton>`
width: 95px;
max - width: 100 %
  font - weight: 400px;
border: 1px solid white;
background: transparent;
height: 30px;
padding: 4px 4px;
border - radius: 6px;
align - items: center;
position: relative;
margin - left: 8px;
gap: 6px;
display: flex;

.icon{
  display: flex;
  align - items: center;
}


`;
export const SuccessButton = styled(Button)<ISuccessButton>`
width: 288px;
max - width: 100 %
  font - weight: 400px;
margin - top: ${({ marginTop }) => (marginTop ? marginTop : '30px')};

@media screen and(max - width: 480px) {
  width: 328px;
  margin - top: ${({ marginTop }) => (marginTop ? marginTop : '16px')};
}
`;
export const OneClickButton = styled(Button)<ISuccessButton>`
  position: fixed;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #f4f4f4;
  color: black;
  width: 90%;
`;
export const ImageBox = styled.div`
  p {
  margin - top: 20px;
  margin - bottom: 40px;
  font - family: VodafoneLt;
  font - size: 28px;
  line - height: 1.21;
  color: #333;
  @media(max - width: 480px) {
    margin - top: 16px;
    margin - bottom: 32px;
    font - family: VodafoneRg;
    font - size: 20px;
    line - height: 1.4;
  }
}
`;
export const ErrorFragment = styled.div`
display: flex;
flex - direction: column;
align - items: center;
justify - content: center;
padding - top: 80px;
  .errorContainer {
  text - align: center;
}

  .errorImage {
  margin - bottom: 20px;
  width: 100px;
  height: 100px;
}

  p {
  color: white;
  font - size: 24px;
  line - height: 30px;
  margin - bottom: 20px;
}
  .desc {
  font - size: 18px;
  line - height: 22px;
}
`;

export const MobileImageBox = styled.div`
  position: relative;
`;

export const Wrapper = styled.div``;

export const SessionContent = styled.section`

padding-top:80px;
padding-right:24px;
padding-left:24px;
background - color: #f4f4f4;
text - align: center;
@media screen and(max - width: 480px) {
  padding: 16px 16px 32px;
  padding-top:40px;
  text - align: center;
  position: absolute;
  z - index: 1;
  display: flex;
  flex - direction: column;
    & > div: last - child {
    order: 4;
  }
}
`;

export const SessionTitle = styled.h1`
font - family: VodafoneRg;
font - size: 28px;
font - weight: bold;
line - height: 1.21;
color: #333;
margin - bottom: 40px;
@media screen and(max - width: 480px) {
  order: 2;
  margin - bottom: 16px;
  font - size: 24px;
  line - height: 1.25;
}
`;

export const SessionImage = styled.div`
margin - bottom: 20px;
@media screen and(max - width: 480px) {
  order: 1;
  margin - bottom: 32px;
  margin - top: auto;
}
`;

export const SessionDescription = styled.h2`
font - family: VodafoneLt;
font - size: 28px;
line - height: 1.21;
color: #333;
margin - bottom: 40px;
@media screen and(max - width: 480px) {
  order: 3;
  margin - bottom: auto;
  font - family: VodafoneRg;
  font - size: 18px;
  line - height: 1.33;
}
`;

export const SessionButton = styled(Button)`
max - width: 400px;
margin: auto;
`;

export const MobileHeader = styled.div`
display: none;
@media screen and(max - width: 480px) {
  display: flex;
  align - items: center;
  justify - content: center;
  font - family: VodafoneRg;
  font - size: 18px;
  line - height: 1.33;
  color: #333;
  span: first - child {
    flex: 1;
  }
}
`;

export const MobileConvergenceFirstPrice = styled.p`
  span {
    &: nth - child(1) {
    font - family: Helvetica;
  }

    &: nth - child(2) {
    font - weight: bold;
  }
}
`;

export const MobileConvergenceSecondPrice = styled.p`
margin-bottom: 4px;
font-size: 16px;
font-weight: 400;
line-height: 22px;
text-align: left;
  p {
  padding - top: 8px;
  padding - bottom: 8px;
}


}
`;

export const MobileConvergenceFirstPriceFront = styled.p`
  span {
    &: nth - child(1) {
    font - family: Helvetica;
  }

    &: nth - child(2) {
    font - family: Helvetica;
    font - weight: bold;
  }
}
`;

export const MobileConvergenceSecondPriceFront = styled.p`
margin - bottom: 4px;
color:#ffff;
padding:4px 16px 12px 16px;
font - size: 20px;
line - height: 22px;
text - align: left;
  p {
  padding - top: 8px;
  padding - bottom: 8px;
}
}
`;

export const MobileCardDiscountedPrice = styled.p`
  span {
    &:first-child {
      text-decoration: line-through;
      font-size: 16px;
    }
    &:last-child {
      font-weight: bold;
      font-size: 22px;
    }
  }
`;

export const MobileCardCampaignPrice = styled.p`
  margin-bottom: 6px;

  span {
    font-weight: bold;
    font-size: 22px;
  }
`;
export const OneClickConvergenceSecondPrice = styled.p`

  color: white;
  p {
    padding-top: 4px;
    margin-bottom:4px;
  }
  }

    &: nth - child(2) {
    font - family: Helvetica;
    font - weight: bold;
  }
}
`;

export const Footer = styled.div`
min - height: 76px;
background: linear - gradient(270deg, #333332 0 %, #000000 100 %);
display: flex;
//align-items: space-between;
flex - direction: column;
color: #ffffff;
justify - content: center;
padding: 26px 100px 39px 100px;
@media screen and(max - width: 1200px) {
  padding: 24px 16px 24px 16px;
}
`;

export const FooterFirstSection = styled.div`
flex: 1;
display: flex;
align - items: center;
justify - content: space - between;

  p {
  font - size: 28px;
  font - family: VodafoneLt;
  line - height: 32px;
}

  div {
  display: flex;
  align - items: center;
  justify - content: space - between;
  gap: 40px;

    p {
    font - size: 18px;
    line - height: 22px;
  }

    div {
    height: 36px;
    border - left: 1px solid #ebebeb;
  }
}

@media screen and(max - width: 1200px) {
  flex - direction: column;
  justify - content: center;
  align - items: center;
  gap: 16px;
    p {
    font - size: 20px;
    line - height: 22px;
  }

    div {
    flex - direction: column;
    justify - content: center;
    align - items: center;
    gap: 16px;

      div {
      width: 94.5px;
      height: 2px;
      border - left: unset;
      border - top: 1px solid #ebebeb;
    }

      p {
      text - align: center;

        span {
        margin - top: 16px;
        display: block;
      }
    }
  }
}
`;
export const FooterSecondSection = styled.div`
display: flex;
align - items: center;
justify - content: space - between;
margin - top: 20px;

  p {
  font - size: 32px;
  line - height: 36.67px;
}

  div {
  display: flex;
  align - items: center;
  gap: 16px;

    span {
    cursor: pointer;
  }
}

@media screen and(max - width: 1200px) {
  flex - direction: column;
    p {
    margin - bottom: 20px;
    font - size: 18px;
    line - height: 21px;
  }

    div {
      span {
      border - radius: 8px!important;
      border: 1px solid #fff!important;

        &: nth - child(3) {
        display: none!important;
      }

      width: 160px!important;
    }
  }
}

@media screen and(max - width: 768px) {
    div {
      span {
      width: 116px!important;
      height: 40px!important;
    }
  }
}
`;

export const FooterThirdSection = styled.div`
margin - top: 20px;
display: flex;
align - items: center;
justify - content: space - between;

  div {
  display: flex;
  align - items: center;
  gap: 20px;

    p {
    cursor: pointer;
  }

    div {
    height: 36px;
    border - left: 1px solid #ebebeb;
  }
}

@media screen and(max - width: 1200px) {
  flex - direction: column;
  gap: 16px;
    div {
    flex - direction: column;

      div {
      display: none;
    }
  }
}
`;
export const ModalWrapperUpsell = styled.div`
width: 100 %;
height: 100 %;
background: linear - gradient(
  90deg,
  #ce1417 0 %,
  #e00a14 16.52 %,
  #e21114 29.94 %,
  #e21114 99.1 %
  );
display: flex;
flex - direction: column;
border - radius: 6px;
@media(max - width: ${theme.breakpoint.small}) {
  width: 100 %;
  height: 500px;
}
`;

export const AbsoluteDivUpsell = styled(Div)`
position: absolute;
right: 15px;
top: 40px;
cursor: pointer;
z - index: 2;
@media(max - width: ${theme.breakpoint.medium}) {
}
`;

export const UpsellHeader = styled.div`
color: white;
display: flex;
align - items: center;
justify - content: center;
padding: 30px 16px;
@media(max - width: ${theme.breakpoint.medium}) {
  padding: 10px 16px;
  margin - bottom: -20px;
  z - index: 2;
}
`;
export const UpsellFooter = styled.div`
color: white;
justify - content: space - between;
display: flex;
align - items: center;
width: 610px;
height: 92px;
background: white;
@media(max - width: ${theme.breakpoint.medium}) {
  width: 328px;
  height: 140px;
  flex - direction: column;
  width: 100 %;
}
`;
export const UpsellButtonWrapper = styled.div`
color: white;
justify - content: space - between;
display: flex;
align - items: center;
backgorund - color: white;
width: 300px;
height: 45px;
margin: 0px 24px;
@media(max - width: ${theme.breakpoint.medium}) {
  width: 100 %;
  height: 140px;
  flex - direction: column;
  padding: 10px 24px 10px 24px;
}
`;
export const ModalUpsellContent = styled.div`
display: flex;
flex - wrap: wrap;
background: linear - gradient(85deg, #820000, #e60000);
width: 100 %;
height: 350px;
padding: 0px;
background - image: url('https://cms.vodafone.com.tr/static/img/content/23-03/23/img.svg');
@media(max - width: ${theme.breakpoint.small}) {
  width: 100 %;
  height: 100 %;
  background - position: center;
  background - size: cover;
  background - repeat: no - repeat;
  background - image: url('https://cms.vodafone.com.tr/static/img/content/23-03/27/upsellmobile.svg');
}
`;
